import React from 'react';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { Center, Flex, Text } from '@chakra-ui/react';

type WarningTextProps = {
  warningText: string;
};

export const WarningText = ({ warningText }: WarningTextProps) => {
  return (
    <Flex backgroundColor={'orange.500'} my={1} py={1} px={2} borderRadius={6}>
      <Center p={1}>
        <WarningTwoIcon />
      </Center>
      <Text textAlign="left" fontSize="16px" fontWeight={'bold'}>
        {warningText}
      </Text>
    </Flex>
  );
};
